class CollectionImageViewToggle extends HTMLElement {
  static STORAGE_KEY = 'catwwr-collection-image-view';
  static DEFAULT_VIEW = 'product';

  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-image-view]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    this.syncFromStorage();
  }

  onButtonClick(event) {
    const button = event.currentTarget;
    const view = button.dataset.imageView;
    if (!view || view === CollectionImageViewToggle.getStoredView()) return;

    CollectionImageViewToggle.setView(view);
  }

  syncFromStorage() {
    const view = CollectionImageViewToggle.getStoredView();
    this.buttons.forEach((button) => {
      const isActive = button.dataset.imageView === view;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  static getStoredView() {
    try {
      const stored = window.localStorage.getItem(CollectionImageViewToggle.STORAGE_KEY);
      return stored === 'lifestyle' ? 'lifestyle' : CollectionImageViewToggle.DEFAULT_VIEW;
    } catch (error) {
      return CollectionImageViewToggle.DEFAULT_VIEW;
    }
  }

  static setView(view) {
    const normalizedView = view === 'lifestyle' ? 'lifestyle' : CollectionImageViewToggle.DEFAULT_VIEW;

    try {
      window.localStorage.setItem(CollectionImageViewToggle.STORAGE_KEY, normalizedView);
    } catch (error) {
      /* ignore storage failures */
    }

    CollectionImageViewToggle.applyToGrid(normalizedView);
    document.querySelectorAll('collection-image-view-toggle').forEach((toggle) => {
      toggle.syncFromStorage();
    });
  }

  static applyToGrid(view) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    grid.dataset.imageView = view === 'lifestyle' ? 'lifestyle' : 'product';
  }

  static init() {
    CollectionImageViewToggle.applyToGrid(CollectionImageViewToggle.getStoredView());

    if (typeof FacetFiltersForm !== 'undefined' && !FacetFiltersForm._collectionImageViewPatched) {
      const originalRender = FacetFiltersForm.renderProductGridContainer.bind(FacetFiltersForm);
      FacetFiltersForm.renderProductGridContainer = (html) => {
        originalRender(html);
        CollectionImageViewToggle.applyToGrid(CollectionImageViewToggle.getStoredView());
      };
      FacetFiltersForm._collectionImageViewPatched = true;
    }
  }
}

customElements.define('collection-image-view-toggle', CollectionImageViewToggle);

document.addEventListener('DOMContentLoaded', () => {
  CollectionImageViewToggle.init();
});
